var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "157px",
    height: "219px",
    viewBox: "0 0 157 219",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.4,89.9 C68.000023,90.3 72.899974,90.3 78.1,89.9 C83.300026,89.499998 88.1499775,88.3500095 92.65,86.45 C97.1500225,84.5499905 100.849985,81.800018 103.75,78.2 C106.650014,74.599982 108.1,69.80003 108.1,63.8 C108.1,54.799955 105.10003,47.900024 99.1,43.1 C93.09997,38.299976 86.200039,35.9 78.4,35.9 C67.599946,35.9 59.4500275,39.4499645 53.95,46.55 C48.4499725,53.6500355 45.799999,62.599946 46,73.4 L5.5,73.4 C5.900002,62.599946 7.8499825,52.7500445 11.35,43.85 C14.8500175,34.9499555 19.7499685,27.300032 26.05,20.9 C32.3500315,14.499968 39.899956,9.5500175 48.7,6.05 C57.500044,2.5499825 67.299946,0.8 78.1,0.8 C86.500042,0.8 94.899958,2.0499875 103.3,4.55 C111.700042,7.0500125 119.249966,10.799975 125.95,15.8 C132.650033,20.800025 138.099979,26.899964 142.3,34.1 C146.500021,41.300036 148.6,49.599953 148.6,59 C148.6,69.200051 146.150024,78.199961 141.25,86 C136.349975,93.800039 129.000049,99.099986 119.2,101.9 L119.2,102.5 C130.800058,105.100013 139.899967,110.699957 146.5,119.3 C153.100033,127.900043 156.4,138.19994 156.4,150.2 C156.4,161.200055 154.250021,170.999957 149.95,179.6 C145.649978,188.200043 139.900036,195.399971 132.7,201.2 C125.499964,207.000029 117.200047,211.399985 107.8,214.4 C98.399953,217.400015 88.600051,218.9 78.4,218.9 C66.599941,218.9 55.8500485,217.200017 46.15,213.8 C36.4499515,210.399983 28.200034,205.450033 21.4,198.95 C14.599966,192.449968 9.3500185,184.500047 5.65,175.1 C1.9499815,165.699953 0.199999,154.900061 0.4,142.7 L40.9,142.7 C41.100001,148.300028 41.999992,153.649975 43.6,158.75 C45.200008,163.850026 47.499985,168.249982 50.5,171.95 C53.500015,175.650019 57.2499775,178.599989 61.75,180.8 C66.2500225,183.000011 71.599969,184.1 77.8,184.1 C87.400048,184.1 95.499967,181.15003 102.1,175.25 C108.700033,169.349971 112,161.300051 112,151.1 C112,143.09996 110.450015,137.000021 107.35,132.8 C104.249984,128.599979 100.300024,125.55001 95.5,123.65 C90.699976,121.749991 85.4500285,120.650002 79.75,120.35 C74.0499715,120.049999 68.600026,119.9 63.4,119.9 L63.4,89.9 Z",
    id: "path-1645029666547"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-1645029666547",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1645029666547"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
    d: "M-179,-126 L85.0029159,346.352281",
    id: "Line-2-Copy",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-169,-126 L95.0029159,346.352281",
    id: "Line-2-Copy-2",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-159,-126 L105.002916,346.352281",
    id: "Line-2-Copy-3",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149,-126 L115.002916,346.352281",
    id: "Line-2-Copy-4",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-139,-126 L125.002916,346.352281",
    id: "Line-2-Copy-5",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129,-126 L135.002916,346.352281",
    id: "Line-2-Copy-6",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119,-126 L145.002916,346.352281",
    id: "Line-2-Copy-7",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109,-126 L155.002916,346.352281",
    id: "Line-2-Copy-8",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99,-126 L165.002916,346.352281",
    id: "Line-2-Copy-9",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-89,-126 L175.002916,346.352281",
    id: "Line-2-Copy-10",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-79,-126 L185.002916,346.352281",
    id: "Line-2-Copy-11",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69,-126 L195.002916,346.352281",
    id: "Line-2-Copy-12",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59,-126 L205.002916,346.352281",
    id: "Line-2-Copy-13",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49,-126 L215.002916,346.352281",
    id: "Line-2-Copy-14",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39,-126 L225.002916,346.352281",
    id: "Line-2-Copy-15",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29,-126 L235.002916,346.352281",
    id: "Line-2-Copy-16",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19,-126 L245.002916,346.352281",
    id: "Line-2-Copy-17",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9,-126 L255.002916,346.352281",
    id: "Line-2-Copy-18",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,-126 L265.002916,346.352281",
    id: "Line-2-Copy-19",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,-126 L275.002916,346.352281",
    id: "Line-2-Copy-20",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,-126 L285.002916,346.352281",
    id: "Line-2-Copy-21",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,-126 L295.002916,346.352281",
    id: "Line-2-Copy-22",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,-126 L305.002916,346.352281",
    id: "Line-2-Copy-23",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,-126 L315.002916,346.352281",
    id: "Line-2-Copy-24",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,-126 L325.002916,346.352281",
    id: "Line-2-Copy-25",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,-126 L335.002916,346.352281",
    id: "Line-2-Copy-26",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,-126 L345.002916,346.352281",
    id: "Line-2-Copy-27",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,-126 L355.002916,346.352281",
    id: "Line-2-Copy-28",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,-126 L365.002916,346.352281",
    id: "Line-2-Copy-29",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,-126 L375.002916,346.352281",
    id: "Line-2-Copy-30",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,-126 L385.002916,346.352281",
    id: "Line-2-Copy-31",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,-126 L395.002916,346.352281",
    id: "Line-2-Copy-32",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029666547)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default ForwardRef;